import { Redirect } from "react-router-dom";

// Authentication
import Login from "pages/Authentication/Login";

// Dashboard
import Dashboard from "pages/Dashboard/Dashboard";
import TicketList from "pages/Dashboard/Tickets/List";
import TicketCreate from "pages/Dashboard/Tickets/Create";
import TicketUpdate from "pages/Dashboard/Tickets/Update";
import DepartureList from "pages/Dashboard/Departures/List";
import DepartureCreate from "pages/Dashboard/Departures/Create";
import DepartureUpdate from "pages/Dashboard/Departures/Update";
import ConfiscationList from "pages/Dashboard/Confiscations/List";
import ConfiscationCreate from "pages/Dashboard/Confiscations/Create";
import SubproductRegister from "pages/Dashboard/Subproducts/Register";
import SubproductCreate from "pages/Dashboard/Subproducts/Create";

// Users
import UserList from "pages/Users/List";
import UserCreate from "pages/Users/Create";
import UserUpdate from "pages/Users/Update";

// Clients
import ClientList from "pages/Clients/List";
import ClientCreate from "pages/Clients/Create";
import ClientUpdate from "pages/Clients/Update";

// Vehicles
import VehicleList from "pages/Vehicles/List";
import VehicleCreate from "pages/Vehicles/Create";
import VehicleUpdate from "pages/Vehicles/Update";

// Rates
import RateList from "pages/Rates/List";
import RateCreate from "pages/Rates/Create";
import RateUpdate from "pages/Rates/Update";

// Checks
import CheckList from "pages/Checks/List";
import CheckUpdate from "pages/Checks/Update";

// Consignments
import ConsignmentList from "pages/Consignments/List";
import ConsignmentUpdate from "pages/Consignments/Update";
import Reports from "pages/Reports/Reports";

// Reports
import Income from "pages/Reports/Income";
import Account from "pages/Reports/Account";
import AccountDetail from "pages/Reports/AccountDetail";
import Daily from "pages/Reports/Daily";
import Vehicle from "pages/Reports/Vehicle";
import DailyList from "pages/Reports/DailyList";
import Subproducts from "pages/Reports/Subproducts";

const userRoutes = [
  // Dashboard
  { path: "/dashboard", component: Dashboard },
  { path: "/tickets", component: TicketList },
  { path: "/tickets/create", component: TicketCreate },
  { path: "/tickets/update/:id", component: TicketUpdate },
  { path: "/departures", component: DepartureList },
  { path: "/departures/create/:id", component: DepartureCreate },
  { path: "/departures/update/:id", component: DepartureUpdate },
  { path: "/confiscations", component: ConfiscationList },
  { path: "/confiscations/create/:id", component: ConfiscationCreate },
  { path: "/subproducts", component: SubproductRegister },
  { path: "/subproducts/create", component: SubproductCreate },

  // Users
  { path: "/users", component: UserList },
  { path: "/users/create", component: UserCreate },
  { path: "/users/update/:id", component: UserUpdate },

  // Clients
  { path: "/clients", component: ClientList },
  { path: "/clients/create", component: ClientCreate },
  { path: "/clients/update/:id", component: ClientUpdate },

  // Vehicles
  { path: "/vehicles", component: VehicleList },
  { path: "/vehicles/create", component: VehicleCreate },
  { path: "/vehicles/update/:id", component: VehicleUpdate },

  // Rates
  { path: "/rates", component: RateList },
  { path: "/rates/create", component: RateCreate },
  { path: "/rates/update/:id", component: RateUpdate },

  // Checks
  { path: "/checks", component: CheckList },
  { path: "/checks/update/:id", component: CheckUpdate },

  // Consignments
  { path: "/consignments", component: ConsignmentList },
  { path: "/consignments/update/:id", component: ConsignmentUpdate },

  // Reports
  { path: "/reports", component: Reports },
  { path: "/reports/income", component: Income },
  { path: "/reports/account", component: Account },
  { path: "/reports/account/:id", component: AccountDetail },
  { path: "/reports/daily", component: Daily },
  { path: "/reports/vehicle", component: Vehicle },
  { path: "/reports/daily_list", component: DailyList },
  { path: "/reports/subproducts", component: Subproducts },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const authRoutes = [{ path: "/login", component: Login }];

export { userRoutes, authRoutes };
